export const NetworkIds=[
    {
        value: 1,
        text: "Ethereum" 
    },
    {
        value: 137,
        text: "Polygon"
    }
]